<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <div class="cen">
        <v-card class="card">
          <h4 class="bankT">Electricity</h4>
          <v-row>
            <v-col>
              <div class="labelDiv">
                <label><b>Select disco</b><span>*</span> </label>
              </div>
              <div class="selectDiv">
                <v-select
                  v-model="disco"
                  item-text="label"
                  :items="discoList"
                  solo
                  append-icon="mdi-menu-down"
                >
                </v-select>
              </div>
              <br />
              <div class="labelDiv">
                <label><b>Meter number</b></label>
              </div>
              <v-text-field type="number" v-model="meterNumber" outlined>
              </v-text-field>
              <div class="labelDiv">
                <label><b>Amount</b></label>
              </div>
              <v-text-field type="number" v-model="amount" outlined>
              </v-text-field>
              <div class="labelDiv">
                <label><b>Customer Phone Number</b></label>
              </div>
              <v-text-field type="number" v-model="customerNumber" outlined>
              </v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="buyElectricity()"
              large
              dark
              class="nextBtn"
              color="blue-grey"
            >
              Proceed
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <v-dialog v-model="detail.dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <b><span class="headline">Confirm</span></b>
            </v-card-title>
            <v-card-text>
              <v-container>
                <hr />
                <v-row>
                  <v-col cols="12" sm="4">
                    <p><b>Customer Name</b></p>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{ detail.customerName }}</p>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <p><b>Disco</b></p>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{ disco }}</p>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <p><b>Meter Number</b></p>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{ meterNumber }}</p>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <p><b>Amount</b></p>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{ amount }}</p>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <p><b>Customer Number</b></p>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <p>{{ customerNumber }}</p>
                  </v-col>
                </v-row>
                <hr />
              </v-container>
              <small>*teller</small>
              <v-row v-if="detail.meterToken != ''">
                <v-col cols="12" sm="4">
                  <b><span class="headline">Meter Token :</span></b>
                </v-col>
                <v-col cols="12" sm="8">
                  <p>{{ detail.meterToken }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                  <p><b class="headline">Units :</b></p>
                </v-col>
                <v-col cols="12" sm="8">
                  <p>{{ detail.units }}</p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="detail.meterToken == ''"
                color="blue darken-1"
                text
                @click="close()"
                >Close</v-btn
              >
              <v-btn
                v-if="detail.meterToken == ''"
                dark
                color="pink"
                @click="ConfirmBuyElectricity()"
                >Proceed</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
            <br />
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";

export default {
  metaInfo: {
    title: "Teller/Electricity",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
  },
  computed: {
    detail() {
      return this.$store.getters.getElectDetail;
    },
    User() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    close() {
      this.$store.commit("setDialog", false);
    },
    navigate(to) {
      this.$router.push({ name: to });
      this.$store.commit("setDialog", false);
    },
    ConfirmBuyElectricity() {
      let payload = {
        customerID: this.User.customerID,
        pin: this.User.pin,
        amount: this.amount,
        meterNumber: this.meterNumber,
        disco: this.disco,
        accessToken: this.detail.accessToken,
        referenceId: this.detail.referenceId,
        customerNumber: this.customerNumber,
        email: this.User.email,
        route: this.$router,
      };
      this.$store.dispatch("ConfirmBuyElectricity", payload);
    },
    buyElectricity() {
      if (this.meterNumber == "" || this.disco == "") {
        let payload = {
          status: true,
          message: "Fill out all the required fields",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      if (this.amount < 700) {
        let payload = {
          status: true,
          message: "minimum amount required is 700",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = {
        customerID: this.User.customerID,
        pin: this.User.pin,
        meterNumber: this.meterNumber,
        disco: this.disco,
        route: this.$router,
      };
      this.$store.dispatch("buyElectricity", payload);
    },
  },
  data: () => ({
    meterNumber: "",
    amount: "",
    customerNumber: "",
    disco: "",
    discoList: [
      {
        label: "AEDC",
        value: "AEDC",
      },
      {
        label: "AEDC_Postpaid",
        value: "AEDC_Postpaid",
      },
      {
        label: "Ikeja_Electric_Bill_Payment",
        value: "Ikeja_Electric_Bill_Payment",
      },
      {
        label: "Ikeja_Token_Purchase",
        value: "Ikeja_Token_Purchase",
      },
      {
        label: "Eko_Prepaid",
        value: "Eko_Prepaid",
      },
      {
        label: "Eko_Postpaid",
        value: "Eko_Postpaid",
      },
      {
        label: "Ibadan_Disco_Prepaid",
        value: "Ibadan_Disco_Prepaid",
      },
      {
        label: "Kano_Electricity_Disco",
        value: "Kano_Electricity_Disco",
      },
      {
        label: "Kaduna_Electricity_Disco",
        value: "Kaduna_Electricity_Disco",
      },
      {
        label: "Kaduna_Electricity_Disco_Postpaid",
        value: "Kaduna_Electricity_Disco_Postpaid",
      },
      {
        label: "Jos_Disco",
        value: "Jos_Disco",
      },
      {
        label: "PhED_Electricity",
        value: "PhED_Electricity",
      },
    ],
  }),
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody"
    "mainBody mainBody mainBody";
}
.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}
.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 10px;
}
.cen {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  padding: 20px;
  width: 600px;
  border-radius: 10px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}

.bankT {
  text-align: center;
  color: #ad1684;
}
.cardR {
  margin: 10px;
  margin-left: 20px;
  margin-right: 20px;
}
.RlistM {
  overflow: scroll;
}
.maf {
  margin-right: 4px;
}
.select {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  background-color: #e3e3e3;
}

.selectDiv {
  position: relative;
}
.selectarrow {
  position: absolute;
  top: 15px;
  right: 10px;
  background-color: #ad1684;
}
.iconColor {
  color: white;
  font-size: 15px;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
  text-transform: none;
}
.labelDiv {
  margin-bottom: 5px;
  margin-top: 5px;
}
@media only screen and (max-width: 1024px) {
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 30px;
    padding-top: 40px;
  }
  .color {
    color: #ad1684;
    font-size: 12px;
  }
  .card {
    padding: 20px;
    width: 600px;
    border-radius: 10px !important;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
